import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { RecoverUserService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import RecoverUserName from './RecoverUserName';

function RecoverUserNameContainer() {
    const { toast } = useGlobalContext();

    const [loader, setLoader] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    const { register, handleSubmit, watch, setError, formState } = useForm();

    const onSubmit = async (data) => {
        // console.log(data);
        try {
            setLoader(true);

            const recoverUserName = await RecoverUserService.send({ ...data });

            if (recoverUserName) {
                setEmailSent(true);
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <RecoverUserName
            functions={{
                register,
                handleSubmit,
                watch,
                setError,
                formState,
                onSubmit,
            }}
            states={{ emailSent }}
        />
    );
}

export default RecoverUserNameContainer;
